<template>
  <div class="leave-wrap">
    <div class="search-wrap">
      <div class="search">
        <div class="btns">
          <!-- 搜索框 -->
          <!-- <van-search class="search-bar"
                      v-model="searchText"
                      placeholder="请输入用户名/姓名"
                      shape="round"
                      @search="onSearch"
          @clear="onSearch"></van-search>-->
          <!-- 筛选按钮 -->
          <div class="select-btn flex-center" @click="showScreen = !showScreen">
            <i class="iconfont" style="font-size: 18px;">&#xe709;</i>&nbsp;筛选
          </div>
        </div>
      </div>
      <!-- 筛选组件 -->
      <screen-items v-show="showScreen" @submitFun="submitHan"></screen-items>
      <div v-show="!showScreen">
        <van-pull-refresh v-if="total > 0 " v-model="isLoading" @refresh="onRefresh">
          <van-list
            class="refreshWrap"
            v-model="isRefresh"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <ul class="leave-list">
              <li
                class="leave-item clearfix"
                v-for="item in list"
                :key="item.LeaveApplicationID"
                @click="editApply(item)"
              >
                <div class="left fl">
                  <img class="left-img" v-if="item.Icon" :src=" item.Icon" />
                  <span v-else>
                    {{xy.showName(item.ApplicantName)}}
                  </span>
                </div>
                <div class="right">
                  <div class="title">
                    <!-- ApplicationType 2:代请假 1:自己请假 -->
                    <div
                      class="nowrap tit"
                    >{{item.ApplicantName}}提交的{{item.ApplicationType === 2?'代':''}}请假申请</div>
                    <div class="date fr">{{xy.moment(item.CreateByDate).format("YYYY-MM-DD HH:mm")}}</div>
                  </div>
                  <!-- IsCycleLeave true周期性请假 -->
                  <div
                    class="type"
                  >请假类型：{{item.LeaveTypeName}}&nbsp;&nbsp;{{item.IsCycleLeave?'周期性请假':''}}</div>
                  <div class="info">
                    <img :src="cardImgUrl" alt />
                    <div class="right-con">
                      <p>
                        <span class="date">
                          {{ xy.moment(item.StartTime).format("YYYY-MM-DD") }}
                          {{!item.IsCycleLeave? xy.moment(item.StartTime).format("HH:mm"):'' }}
                        </span>
                      </p>
                      <p>
                        <span class="date">
                          {{ xy.moment(item.EndTime).format("YYYY-MM-DD") }}
                          {{!item.IsCycleLeave? xy.moment(item.EndTime).format("HH:mm"):'' }}
                        </span>
                      </p>
                    </div>
                  </div>
                  <!-- 0待审批，1审批中，2已通过，3已拒绝，4已撤销，5已过期 （40已撤回） -->
                  <div
                    class="status"
                    v-if="item.ApplicationState !== -1"
                    :style="{color: (item.ApplicationState === 0 ? '#4196FF' : item.ApplicationState === 1 ? '#E8A022' : item.ApplicationState === 2 ? '#21A83E' : item.ApplicationState === 3 ? '#D83737' : item.ApplicationState === 4 ? '#666666' : item.ApplicationState === 5 ? '#666666' : '')}"
                  >{{item.ApplicationStateName}}</div>
                </div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
        <no-data v-else :needBg="true" class="footer"></no-data>
      </div>
    </div>
    <SingleBottomBtn @clickBtn="createApproval">创建申请</SingleBottomBtn>
  </div>
</template>
<script>
import SingleBottomBtn from "../../components/SingleBottomBtn";
import ScreenItems from "../../components/ScreenItems";
import NoData from "@/components/noData/Index";

const cardImgUrl = require("@/assets/attendance/data_ask.png");
export default {
  name: "StudentLeaveSubApproval",
  components: {
    ScreenItems,
    SingleBottomBtn,
    NoData
  },
  data() {
    return {
      cardImgUrl: cardImgUrl,
      showScreen: false,
      imgUrl: this.xyMApi + '/base',
      searchText: "",
      leaveTypeID: -1,
      applicationState: -1,

      startDate: "", //开始时间
      endDate: "", //结束时间

      //list
      isLoading: false, //下拉刷新状态
      pageIndex: 1,
      pageSize: 15,
      isRefresh: false, // 是否加载中
      finished: false, // 加载是否完成
      list: [],
      total: 0
    };
  },
  created() {
    this.resetAndLoad();
  },
  methods: {
    async onLoad() {
      // this.xy.loading();
      var params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        studentName: this.searchText,
        leaveTypeID: this.leaveTypeID, //请假类型
        applicationState: this.applicationState, //请假状态
        schoolDistrictID: 0,
        studentGradeForStudentYearID: 0,
        studentOrganizationID: 0,
        startDate: this.startDate, //开始时间
        endDate: this.endDate //结束时间
      };
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/StudentLeaveMb/SelfApplyGetPageMobile",
        params
      );
      if (res.success) {
        this.xy.unloading();
        this.total = res.data.totalRecords;
        let _list = res.data.data;
        this.list = [...this.list, ..._list];
        this.pageIndex++;
        this.finished =
          this.list.length >= res.data.totalRecords ? true : false;
      } else {
        this.xy.unloading();
        this.$toast.fail(res.msg);
      }
      // 加载状态结束
      this.isRefresh = false;
    },
    onRefresh() {
      setTimeout(() => {
        this.list = [];
        this.pageIndex = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
    //重置条件
    resetAndLoad() {
      this.pageIndex = 1;
      this.list = [];
      this.onLoad();
    },
    //用户名搜索
    onSearch() {
      this.finished = false;
      this.resetAndLoad();
    },
    //监听提交下拉筛选
    submitHan($event) {
      this.leaveTypeID = $event.leaveType;
      this.applicationState = $event.approvalStatus;
      this.startDate = $event.startDate;
      this.endDate = $event.endDate;

      this.showScreen = false;
      this.finished = false;
      setTimeout(() => {
        this.resetAndLoad();
      }, 500);
    },
    // 查看详情
    editApply(item) {
      this.$router.push({
        path: "/home/StudentLeave/Create",
        query: {
          params: JSON.stringify(item),
          status: "edit",
          originPage: "apply"
        }
      });
    },
    // 创建请假
    createApproval() {
      this.$router.push({
        path: "/home/StudentLeave/Create",
        query: { status: "create", originPage: "apply" }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.leave-wrap {
  padding-bottom: 80px;
  .search-wrap {
    .search {
      display: flex;
      background: #fff;
      height: 100px;
      padding: 0 15px;
      .btns {
        flex: 2;
        display: flex;
        color: #505050;
        .search-btn {
          flex: 1;
        }
        .search-bar {
          flex: 4;
        }
        .select-btn {
          flex: 1;
        }
      }
    }
  }
  // list
  .refreshWrap {
    padding-bottom:40px;
    .leave-list {
      padding: 15px;
      .leave-item {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
        margin-bottom: 16px;
        padding: 12px 31px 22px 19px;
        .left {
          width: 64px;
          height: 64px;
          display: flex;
          align-items: center;
          justify-content: center;
          .left-img{
            width:100%;
            height:100%;
            border-radius: 50%;
          }
          span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 64px;
            height: 64px;
            text-align: left;
            border-radius: 50%;
            background: @blue;
            font-size: 22px;
            color: #fff;
            overflow: hidden;
            img {
              width: 100%;
            }
          }
        }
        .right {
          padding-left: 87px;
          .title {
            display: flex;
            justify-content: space-between;
            .tit {
              flex: 1;
              max-width: 60%;
              font-size: 30px;
              line-height: 64px;
              font-weight: bold;
              color: #333;
            }
            .date {
              line-height: 64px;
              color: #b4b4b4;
              font-size: 24px;
            }
          }
          .type {
            font-size: 24px;
            color: #999;
            width: fit-content;
            height: 36px;
            line-height: 36px;
            padding: 0 20px 0 11px;
            background: rgba(249, 249, 249, 1);
            border-radius: 14px 0px 14px 0px;
          }
          //请假周期时间
          .info {
            margin-top: 15px;
            display: flex;
            color: #666;
            img {
              width: 13px;
              height: 73px;
              margin-top: 10px;
              margin-right: 10px;
            }
            .right-con {
              font-size: 26px;
              .date {
                margin-right: 10px;
              }
              p:first-child {
                margin-top: 2px;
              }
              p:last-child {
                margin-top: 31px;
              }
            }
          }
          //状态
          .status {
            font-size: 28px;
            margin: 17px 0 0;
            color: #666;
          }
        }
      }
    }
  }
}
</style>
